import { Skeleton, Spin } from 'antd'
import Flex from 'components/Flex'
import SearchInput from 'components/SearchInput'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { StyledCheckbox } from 'components/UIComponents/FilterCheckBoxComp/style'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ScrollBar, EmptyText, Empty } from 'components/CommonStyles'

const CollegeNameFilter = ({
  institutesList,
  instituteSearch,
  setInstituteSearch,
  campusIds,
  setCampusIds,
  campusLoading,
  loadMore,
}) => {
  return (
    <Wrapper column>
      <SearchInput
        width={'100%'}
        placeholder={'Search by keyword'}
        searchValue={instituteSearch}
        setSearchValue={setInstituteSearch}
      />
      {institutesList?.result?.length ? (
        <ScrollBar id="scrollableDiv" height={'28vh'}>
          <InfiniteScroll
            dataLength={institutesList?.result?.length}
            next={loadMore}
            hasMore={institutesList?.result?.length < institutesList?.count}
            loader={
              <Flex center>
                <Spin small />
              </Flex>
            }
            scrollableTarget="scrollableDiv"
          >
            <FilterCheckBoxComp
              options={institutesList?.result}
              onChange={values => setCampusIds([values[values?.length - 1]])}
              value={campusIds}
              valueParam="instituteCampusId"
              labelParam="instituteCampusName"
            />
          </InfiniteScroll>
        </ScrollBar>
      ) : campusLoading ? (
        <Flex spaceBetween centerVertically>
          <Skeleton
            active
            paragraph={{ rows: 1 }}
            title={false}
            avatar={{ size: 'small', shape: 'square' }}
            style={{ marginTop: '10px' }}
          >
            <StyledCheckbox />
          </Skeleton>
        </Flex>
      ) : (
        <Empty
          padding={'50px 0px 0px 0px'}
          height={'75px'}
          description={
            <EmptyText size={'9px'}>No InstituteCampus found!</EmptyText>
          }
        />
      )}
    </Wrapper>
  )
}

export default CollegeNameFilter
